import { isNotNullish, isNullish } from '@y42/util/nullish';
import * as go from 'gojs';
import { iteratorToArray } from '../../../../../utils/iterator-to-array';
import { sidebarNodeTypes } from '../../../config/config';
import { ATTACHED_TO_PROP } from '../../common/config/common-prop-names';
import { animate } from './../../../../../utils/animate/animate';

export const findAttachedAttentionNodes = (
  nodes: go.Iterator<go.Node>,
  attentionCategory: string = sidebarNodeTypes.attentionNode,
): { [key: string]: go.Node } =>
  iteratorToArray(
    nodes.filter((n) => n.category === attentionCategory && n.data && isNotNullish(n.data[ATTACHED_TO_PROP])),
  ).reduce((acc: { [key: string]: go.Node }, node: go.Node) => ({ ...acc, [node.data[ATTACHED_TO_PROP]]: node }), {});

export const calculateAttentionNodeLocation = (attachToPart: go.Part): go.Point => {
  let { x, y, width } = attachToPart.actualBounds;
  if (attachToPart.selectionObject !== attachToPart) {
    const { x: sx, y: sy, width: swidth } = attachToPart.selectionObject.actualBounds;
    x += sx;
    y += sy;
    width = swidth;
  }
  return new go.Point(x + width, y);
};

export const attachAttentionNode = (attachToPart: go.Part, attentionNode: go.Node) => {
  if (isNullish(attachToPart?.actualBounds)) {
    return;
  }

  const location = calculateAttentionNodeLocation(attachToPart);
  animate([[attentionNode, 'location', attentionNode.location, location]], {
    duration: 300,
  });

  attentionNode.diagram?.model?.set(attentionNode.data, ATTACHED_TO_PROP, attachToPart.key);
};

export const detachAttentionNode = (attentionNode: go.Part) => {
  attentionNode.diagram?.model?.set(attentionNode.data, ATTACHED_TO_PROP, null);
};
